export class RateScheduleGroupRateScheduleEditor extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.rateScheduleId = this.getAttribute("id")
    this.showFormOnCancel = this.getAttribute("show_form_on_cancel")

    this.rate_schedule_data = []

    this.innerHTML= `
      <div class="row">
        <div class="col-md-6" id="rate_schedule_form_container" style="border:1px solid #ccc;padding:10px;">
          <form>
            <div class="form-group" >
              <label for="rate_schedule_name">Name</label>
              <input type="text" 
                class="form-control" 
                name="rate_schedule_name"
                id="rate_schedule_name"
              placeholder="Name this Rate Schedule">
            </div>


            <div>
              <label for="rate_schedule_price">Base Price</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <input type="number" 
                  class="form-control" 
                  step="1"
                  min="0"
                  name="rate_schedule_price"
                  id="rate_schedule_price"
                placeholder="Price for this Billing Plan">
              </div>
            </div>

            <div class="form-group">
              <div id="features">
                <strong>Features</strong>
                <div id="feature_editors_container"></div>
              </div>
            </div>      


            <div class="col-md-12 location-settings-buttons">
              <button 
                type="button" 
                class="btn btn-outline-secondary cancel  detail-row-button">Cancel</button>

              <button 
                type="button" 
                class="btn btn-primary save  detail-row-button" data-cy="save-message-center-settings">Save</button>
            </div>

          </form>
        </div>

        <div class="col-md-6 no-gutters" style="border:1px solid #ccc;">
          <rate-schedule-cards-editor
          rateScheduleId=${this.rateScheduleId}
          ></rate-schedule-cards-editor>            
        </div>

      </div>
    `

    this.querySelector('.btn.save').addEventListener('click', function(e){
      e.preventDefault()
      const form = this.querySelector('form')
      if (this.isValid(form)){
        this.save()
      }
    }.bind(this))

    this.querySelector('.btn.cancel').addEventListener('click', function() {
      this.cancelEdit();
    }.bind(this))

    this.addEventListener('rate_schedule_data', function(e){
      // console.log('editor form received rate schedule data: ', e.detail)
      this.rate_schedule_data = e.detail.data
      this.features_list = this.rate_schedule_data.billing_charges
      delete this.rate_schedule_data.billing_charges
      this.populate_editor_fields()
      this.init_data_changed_emitter()
    }.bind(this))

    this.addEventListener('feature_updated', this.feature_updated_callback)
  }

  cancelEdit() {
    this.remove();
    const el = document.querySelector(`#${this.showFormOnCancel}`)
    if (el){
      el.classList.remove('hidden')
    }
  }  
  
  feature_updated_callback(e){
    // modify the global data to update the charges data with this new data
    for (let i = 0; i < this.rate_schedule_data.rate_schedule_charges_attributes.length; i++){
      const charge = this.rate_schedule_data.rate_schedule_charges_attributes[i]
      const new_charge = e.detail.data
      if (charge.id === new_charge.id){
        this.rate_schedule_data.rate_schedule_charges_attributes[i] = new_charge
        // if any features have been marked for deletion, we can reenbled the feature
        // in the menu to get re-added
        if (new_charge.destroy){
          // this.toggle_feature_menu_option(new_charge.billing_charge_id, true)
        }
        break;
      }
    } // for
    //console.log('updated gRATE_SCHEDULE_DATA',this.rate_schedule_data)

    // when data in an editor has changed, we push data to update the static views. 
    this.querySelector('rate-schedule-card-editor').update(this.rate_schedule_data)
  }

  gather_data(form){
    let name = form.querySelector("#rate_schedule_name").value.trim()
    let price = form.querySelector("#rate_schedule_price").value.trim()
    // keep only numbers and the period
    price = price.replace( /[^0-9.]/g, '' );
    let group_id = this.rate_schedule_data.auto_group_id

    const data = {
      name: name,
      price: price,
      auto_group_id: group_id
    }

    return data
  }

  isValid(form){
    let data = this.gather_data(form)
    let is_valid = true

    // validate data in the billable feature editors
    const multi_editors = this.querySelectorAll('multi-feature-editor')
    const feature_editors = this.querySelectorAll('feature-editor')
    const editors = [...multi_editors, ...feature_editors];
    const invalid_editors = Array.from(editors).filter(editor =>{
      return ! editor.isValid()
    })
    is_valid = (invalid_editors.length === 0)

    let el = form.querySelector("#rate_schedule_name")
    if (data.name === ''){
      el.classList.add("error")
      Common.notify("Please provide a name for this rate schedule","error")
      el.scrollIntoView()
      is_valid = false
    }
    else {
      el.classList.remove("error")
    }


    el = form.querySelector("#rate_schedule_price")
    const price = parseFloat(data.price)
    if (isNaN(price) || price < 1){
      el.classList.add("error")
      Common.notify("Please provide a valid price for this rate schedule","error")
      el.scrollIntoView()
      is_valid = false
    }
    else {
      el.classList.remove("error")
    }

    // if we get here, data is valid
    return is_valid
  }


  isExistingRecord(){
    return typeof this.rate_schedule_data.id === 'number'
  }

  async save(){
    try {
      const post = JSON.parse(JSON.stringify(this.rate_schedule_data))
      post['auto_group_id'] = 0 // this does not seem to be needed anymore
      post['name'] = this.rate_schedule_data.rate_schedule_name
      post.rate_schedule_charges_attributes.map(charge => {

        if (typeof charge['id'] === 'string' || charge['id' === null] || charge['id'] < 0){
          delete charge['id']
        }

        charge.charge_periods_attributes.map(cp => {
          if (cp.id < 0) {
            delete cp.id
          }
        })
      })

      delete post['groups']
      
      //console.log('posting data: ',post)

      pageLoadingFrame("show")

      let enpoint = (this.isExistingRecord()) ? 'update' : 'create'
      let res = await fetch(`/admin/rate_schedules/${enpoint}.json`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(post)
      })

      if (!res.ok) // or check for response.status
        throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        pageLoadingFrame("hide")
        Common.notify('Billing changes Saved!', 'success');
        // pass data to group editor to reload the data
        // we can pass this record_data to the 
        if (response.plans) {
          document.querySelector('rate-schedule-group-editor').update_data(response.plans)
        }
        else {
          document.querySelector('rate-schedule-group-editor').update_data(this.rate_schedule_data)
        }
        this.cancelEdit()
      }
      else {
        pageLoadingFrame("hide")
        Common.notify(`Unable to save data. ${response.error ? response.error : ""}`, 'error');
      }    
    } catch (err) {
      pageLoadingFrame("hide")
      Common.notify('Sorry an error occured unable to save this data', 'error');
    }    
  }

  async generate_group_menu() {
    // only do this if the menu has not been populated yet
    if (this.querySelector('#rate_schedule_group option')){return}

    const groups = this.rate_schedule_data.groups;
    let select_menu = '<select class="form-control" id="rate_schedule_group" > '
    select_menu += `<option value="0">Global Rate Schedule</option>`

    for (let i of groups) {
      let option_html = `<option value=${i['id']}>${i['name']}</option>`
      select_menu += option_html
    }

    select_menu += '</select>'
    $('#rate_schedule_group_container').html(select_menu)
    delete this.rate_schedule_data.groups
  }

  // take data from the web component and populate the form fields
  populate_editor_fields() {
    $('#rate_schedule_name').val( this.rate_schedule_data.rate_schedule_name )

    const base_price = this.querySelector('rate-schedule-card-editor').get_base_price()
    $('#rate_schedule_price').val( base_price )

    this.generate_feature_editors()
  }

  generate_feature_editors() {
    /*
      Because we want to group the two text related features into 1 UI element,
      we remove them from the feature list as we are creating single feature editors.
      Then we will use these two records to make a special ui element that is combined.
    */
    // find those dati that match the text features.
    const single_feature_editors = []
    const multi_feature_editors = {}

    // separate out multi editors and single editors
    this.rate_schedule_data.feature_editor_settings.map(editor => {
      const multi_editor_id = editor.multi_editor_id
      if (multi_editor_id === null) {
        single_feature_editors.push(editor)
      }
      else {
        const data = multi_feature_editors[multi_editor_id] || []
        data.push(editor)
        multi_feature_editors[multi_editor_id] = data
      }
    })
    

    // create the single feature editors
    single_feature_editors.map(feature => {
      if (this.rateScheduleId === "null") {
        this.add_feature_editor(feature, null)
      }
      else {
        const saved_data = this.rate_schedule_data.rate_schedule_charges_attributes.find(el => {
          return el.billing_charge_id === feature.billing_charge_id
        })
        this.add_feature_editor(feature, saved_data)
      }
    })


    // create the multi feature editors
    Object.keys(multi_feature_editors).map(editor => {
      editor = multi_feature_editors[editor]
      this.generate_multi_feature_editor(editor)
    })
  }

  copy_feature_editor_data(destination, feature) {
    destination['price_text'] = feature.fee_text
    destination['quantity_text'] = feature.quantity_text
    destination['hide_fee_input_field'] = feature.hide_fee_input_field
    destination['hide_quantity_input_field'] = feature.hide_quantity_input_field
  }
  
  // renders the combined texting feature
  generate_multi_feature_editor(combined_editor_features) {  
    const title = combined_editor_features[0].name
    if (this.rateScheduleId === "null") {
      this.add_multi_feature_editor(title, combined_editor_features, null)
    }
    else {
      const saved_data = []
      combined_editor_features.map(feature => {
        const temp_data = this.rate_schedule_data.rate_schedule_charges_attributes.find(el => {
          return feature.billing_charge_id == el.billing_charge_id
        })

        if (temp_data) {
          this.copy_feature_editor_data(temp_data, feature)
          saved_data.push(temp_data)
        }
        else {
          // create fake data for new features
          const fake_rate_schedule_charge = this.create_fake_rate_schedule_charge_data(feature.description, feature.billing_charge_id)
          this.copy_feature_editor_data(fake_rate_schedule_charge, feature)
          this.rate_schedule_data.rate_schedule_charges_attributes.push( fake_rate_schedule_charge )
          this.querySelector('rate-schedule-card-editor').update(this.rate_schedule_data)
          saved_data.push(fake_rate_schedule_charge)
        }
      })

      // console.log('saved_data', saved_data)
      this.add_multi_feature_editor(title, combined_editor_features, saved_data)
    }
  }  

  add_multi_feature_editor(title, features, saved_data){
    // console.log('xxxx features',features)
    // console.log('xxxx saved_data',saved_data)

    // iterate over the saved_data and create new dummy data if needed
    let editor_data = []
    if (this.rateScheduleId === "null" || saved_data === null || saved_data === undefined) {
      features.map(feature => {
        const fake_rate_schedule_charge = this.create_fake_rate_schedule_charge_data(feature.description, feature.billing_charge_id)
        this.copy_feature_editor_data(fake_rate_schedule_charge, feature)
        this.rate_schedule_data.rate_schedule_charges_attributes.push( fake_rate_schedule_charge )
        this.querySelector('rate-schedule-card-editor').update(this.rate_schedule_data)
        editor_data.push(fake_rate_schedule_charge)
      })
    }
    else {
      editor_data = saved_data
    }    
  
    // console.log('editor_data',editor_data)
    const feature_editors_container = this.querySelector('#feature_editors_container');
    if (! feature_editors_container) return; // should not happen :)
    editor_data.billing_settings = this.rate_schedule_data.billing_settings
    feature_editors_container.appendChild(new MultiFeatureEditor(title, editor_data)) 
  }

  create_fake_rate_schedule_charge_data(feature_title, feature_id) {
    // first tier represents the included number of features
    // second tier represents the additional usage price
    const faker_tier_data = [{tier_low_value:0, tier_high_value:0, price:0}, {tier_low_value:0, tier_high_value:99999999.0000, price:0}]

    const todays_date = moment(new Date()).format("YYYY/MM/DD");
    // stop in 10 years should be enough
    const end_date = moment(new Date()).add(10,'y').format("YYYY/MM/DD")

    const fake_charge_period = {start_date: todays_date, end_date: end_date, price: 0,charge_period_tiers_attributes: faker_tier_data}

    let unique_hash = Math.random().toString(36).substr(2,9);
    const fake_id = unique_hash
    const fake_rate_schedule_charge = {id: fake_id, rate_schedule_id: this.rateScheduleId, base_price: false, billing_charge_id: feature_id, description:feature_title, billing_direction:'F', grouping_level:'A', grouping_frequency:'M', charge_tier_type:'I', charge_periods_attributes:[fake_charge_period]}

    return fake_rate_schedule_charge
  }
  
  // saved_data will be undefined when there is no matching saved data for a feature
  // within a pre-existing feature editor, so it is considered a new feature.
  //
  // this.rateScheduleId === "null" when adding a new rate schedule.
  // add_feature_editor(feature_title, feature_id, saved_data){
  add_feature_editor(feature, saved_data){
    const feature_title = feature.description
    const feature_id = feature.billing_charge_id

    if (this.rateScheduleId === "null" || saved_data === undefined) {
      const fake_rate_schedule_charge = this.create_fake_rate_schedule_charge_data(feature_title, feature_id)
      this.rate_schedule_data.rate_schedule_charges_attributes.push( fake_rate_schedule_charge )
      this.copy_feature_editor_data(fake_rate_schedule_charge, feature)
      this.generate_feature_editor(fake_rate_schedule_charge)
      this.querySelector('rate-schedule-card-editor').update(this.rate_schedule_data)
    }
    else {
      this.copy_feature_editor_data(saved_data, feature)
      this.generate_feature_editor(saved_data)
    }
  }

  generate_feature_editor(charge) {
    const feature_editors_container = this.querySelector('#feature_editors_container');
    if (! feature_editors_container) return; // should not happen :)
  
    // ignore the base_price charge as that is not a feature
    if (charge.base_price !== true && !charge.destroy) {
      charge.rate_schedule_id = this.rateScheduleId
      charge.billing_settings = this.rate_schedule_data.billing_settings
      feature_editors_container.appendChild(new FeatureEditor(charge)) 
    }
  }

  get_base_price_charge(){
    return this.rate_schedule_data.rate_schedule_charges_attributes.find(charge => {return charge.base_price === true})
  }

  // when the form fields change, we need to push those changes to the view components
  // so they show the recent changes. 
  init_data_changed_emitter(){
    $('#rate_schedule_name').on('keyup', function(){
      const v = $('#rate_schedule_name').val()
      this.rate_schedule_data.rate_schedule_name = v
      this.querySelector('rate-schedule-card-editor').update(this.rate_schedule_data)
    }.bind(this))

    $('#rate_schedule_price').on('input', function(){
      let v = $('#rate_schedule_price').val()
      v = v.replace( /[^0-9.]/g, '' );
      v = parseFloat(v)
      this.rate_schedule_data.rate_schedule_charges_attributes.map(charge => {
        if (charge.base_price === true) {
          charge.charge_periods_attributes[0].price = v
        }
      })
      this.querySelector('rate-schedule-card-editor').update(this.rate_schedule_data)
    }.bind(this))
  }

  action_type(){
    return (record_id() === '' ) ? "create" : "update"
  }
  record_id(){
    return this.rateScheduleId;
  }
}
customElements.define("rate-schedule-group-rate-schedule-editor", RateScheduleGroupRateScheduleEditor)


/*

  Used as the ui component when editing a rate schedule in the billing plan editor.
  We display the billing plan and the modal together so they can be updated and seen
  simultaneously. The only use case for this component is an editor.

  Example to edit a specific rate schedule:
    <rate-schedule-cards-editor
    rateScheduleId=<%= @id %>
    ></rate-schedule-cards-editor>            

*/
class RateScheduleCardEditorsEditor extends HTMLElement {
  constructor() {
    super();
  }
  
  update_plan_data(data){
    this.data = data
    this.refresh_ui()
  }
  
  async loadData(){
    let url = `/admin/rate_schedules/${this.rateScheduleId}/card_editor_data`
    if (this.rateScheduleId === null){
      url = `/admin/rate_schedules/new`
    }
    let res = await fetch(url);
    this.data = await res.json();
    // console.log('RateScheduleCardEditorsEditor data: ',this.data)
  }
  
  async connectedCallback() {
    let tempId = this.getAttribute('rateScheduleId');
    tempId = parseInt(tempId)
    this.rateScheduleId = isNaN(tempId) ? null : tempId
    this.groupId = this.getAttribute('groupId');
    this.editMode = this.getAttribute('editMode')

    await this.loadData()
    this.refresh_ui()
  }

  refresh_ui(){
    this.innerHTML = `
      <style>
        .billing_plans_container {
          display: grid;
          grid-template-columns:fit-content(100%);
          box-sizing: content-box;
          margin: 0 auto;
          padding:20px;
          gap:20px;
        }
      </style>
      <div class="row">
        <template id="additional_charges_template">      
          <div class="content">
            <table class="pricing-table">
              <colgroup>
                <col class="col-headers" />
                <col class="col-data" />
              </colgroup>
              <thead>
                <tr>
                  <td class="info">
                    <p class="title"></p>
                  </td>
                  <th scope="col">
                    <p class="tier">
                      Starting at <span class="price"></span>
                    </p>
                    <p>
                      Monthly fee plus<br />additional usage.
                    </p>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </template>

        <div class="billing_plans_container"></div>
      </div>

      `;


    const billing_plans_container = this.querySelector('.billing_plans_container');
    if (billing_plans_container){
      this.data.map(rate_schedule => {
        billing_plans_container.appendChild(new RateScheduleCardEditor(rate_schedule, billing_plans_container))        
      })
    }
  }
}
customElements.define("rate-schedule-cards-editor", RateScheduleCardEditorsEditor)

import {RateSchedule, RateScheduleCharge} from 'admin/accounting/rate_schedule'
import {RateScheduleCardBase} from 'admin/accounting/rate_schedule_card_base'
import { data } from 'jquery';
import moment from 'moment';

// Represents an individual rate schedule 
class RateScheduleCardEditor extends RateScheduleCardBase {
  constructor(plan, billing_plans_container) {
    super(plan);

    this.billing_plans_container = billing_plans_container;
    // console.log('RateScheduleCardEditor data: ', plan)
  }

  update(new_plan_data){
    this.rateSchedule = new RateSchedule(new_plan_data)
    this.reset()
  }
  
  connectedCallback() {
  // console.log('emiting',this.rateSchedule.data)
    // emit this data to populate the editor fields
    this.dispatchEvent(new CustomEvent('rate_schedule_data', 
      {bubbles: true, composed: true, detail: {data: this.rateSchedule.data}}
    ))

    this.reset()
  }

  reset(){
    this.populate_inner_html_template()

    // when the editor data changes, we need to rebuild the template.
    const mt = this.billing_plans_container.querySelector('#modal_template_container')
    if (mt){
      mt.remove();
    }
    
    // appends the included/additional charges modal content to be displayed
    const modal_template = this.querySelector('#modal_template');
    const node = modal_template.content.cloneNode(true)
    this.billing_plans_container.appendChild(node)  
  }

  get_base_price(){
    return parseInt(this.rateSchedule.get_base_price())
  }
}
customElements.define("rate-schedule-card-editor", RateScheduleCardEditor)

export class FeatureEditor extends HTMLElement {
  constructor(charge) {
    super();
    this.charge = new RateScheduleCharge(charge)
  }

  /*
    Make sure the additional fees are not 0.
  */
  isValid(){
    let result = {"isValid":false, message:""}

    const editors = this.querySelectorAll('charge-period-editor')
    const invalid_editors = Array.from(editors).filter(editor =>{
      return ! editor.isValid()
    })
    result.isValid = (invalid_editors.length === 0)
  
    return result.isValid
  }
  
  connectedCallback() {
    this.refresh()
  }

  refresh() {
    const rate_schedule_has_been_saved = typeof this.charge.data.rate_schedule_id === 'string' && this.charge.data.rate_schedule_id !== "null"
    // feature editor id is a string when new (not saved)
    const editor_is_new_to_rate_schedule = (typeof this.charge.data.id === 'string')
    const feature_is_new_to_rate_schedule = rate_schedule_has_been_saved && editor_is_new_to_rate_schedule

    this.innerHTML = `
      <div class="feature_editor">
        <div class="top_row">
          <h3 clas="col-3">${this.charge.data.description} ${feature_is_new_to_rate_schedule ? "<span class='new_feature_indicator'>(new)</span>" : ""}</h3>
        </div> <!-- top_row -->

        <div class="charge_periods_master_container">
          <div class="editor_contents"></div>
        </div>

      </div> <!-- feature_editor -->
    `

    // create charge period editors
    const container = this.querySelector(".editor_contents")
    this.charge.data.charge_periods_attributes.map(cp => {
      container.appendChild( new ChargePeriodEditor(cp, this.charge))
    })
  }
  
  dispatchFeatureUpdatedEvent(){
    this.dispatchEvent(new CustomEvent('feature_updated', 
      {bubbles: true, composed: true, detail: {data: this.charge.data}}
    ))  
  }
}
customElements.define("feature-editor", FeatureEditor)


// similar to FeatureEdit but allows for multiple editors to be combined into a single ui component.
export class MultiFeatureEditor extends HTMLElement {
  constructor(title, charges) {
    super();
    this.title = title
    this.charges = []
    charges.map(charge => {
      // charge.billing_settings = charges.billing_settings
      this.charges.push( new RateScheduleCharge(charge) )
    })
  }

  /*
    Was used to valid date ranges but that has been removed.
    Kept incase we need it.
  */
  isValid(){
    let result = {"isValid":false, message:""}

    const editors = this.querySelectorAll('charge-period-editor')
    const invalid_editors = Array.from(editors).filter(editor =>{
      return ! editor.isValid()
    })
    result.isValid = (invalid_editors.length === 0)

    return result.isValid
  }
  
  connectedCallback() {
    this.refresh()
  }

  refresh() {
    let rate_schedule_has_been_saved_count = 0
    let editor_is_new_to_rate_schedule_count = 0
    this.charges.map(charge => {
      if (typeof charge.rate_schedule_id === 'string' && charge.rate_schedule_id !== "null") {
        ++rate_schedule_has_been_saved_count
      }


      if (typeof charge.id === 'string'){
        ++editor_is_new_to_rate_schedule_count
      }


    })

    const rate_schedule_has_been_saved = (rate_schedule_has_been_saved_count === this.charges.length)
    const editor_is_new_to_rate_schedule = (editor_is_new_to_rate_schedule_count === this.charges.length)
    const feature_is_new_to_rate_schedule = rate_schedule_has_been_saved && editor_is_new_to_rate_schedule

    this.innerHTML = `
      <div class="feature_editor">
        <div class="top_row">
          <h3 clas="col-3">${this.title} ${feature_is_new_to_rate_schedule ? "<span class='new_feature_indicator'>(new)</span>" : ""}</h3>
        </div> <!-- top_row -->

        <div class="charge_periods_master_container">
          <div class="editor_contents"></div>
        </div>
      </div> <!-- feature_editor -->
    `

    // create charge period editors
    const container = this.querySelector(".editor_contents")
    const showFeatureDescriptionInEditor = true
    this.charges.map(charge => {
      charge.data.charge_periods_attributes.map(cp => {
        container.appendChild( new ChargePeriodEditor(cp, charge, showFeatureDescriptionInEditor))
      })    
    })
  }

  dispatchFeatureUpdatedEvent(){
    this.dispatchEvent(new CustomEvent('feature_updated', 
      {bubbles: true, composed: true, detail: {data: this.charge.data}}
    ))  
  }
}
customElements.define("multi-feature-editor", MultiFeatureEditor)




// Generate the ui for a specific charge period within a rate schedule charge.
// A rate schedule charge may have 1 or more charge periods.
class ChargePeriodEditor extends HTMLElement {
  constructor(data, charge, showFeatureDescriptionInEditor = false) {
    super();
    this.data = data
    this.charge = charge // class RateScheduleCharge
    this.showFeatureDescriptionInEditor = showFeatureDescriptionInEditor
  }

  /*
    Make sure the additional fees are not 0.
  */
  isValid(){
    let result = {"isValid":false, message:""}
    const price_el = this.querySelector('#price')
    const v = price_el.value
    const price = parseFloat(v)

    if (price > 0) {
      result.isValid = true
      price_el.classList.remove("error")
    }
    else if (price < 0) {
      const msg = `Additional fees for ${this.charge.data.description} cannot be negative.`
      result.message = msg
      price_el.classList.add("error")
      Common.notify(msg, "error")
    }
    else {
      const msg = `Additional fees for ${this.charge.data.description} cannot be zero.`
      result.message = msg
      price_el.classList.add("error")
      Common.notify(msg, "error")
    }
  
    return result.isValid
  }
    
  connectedCallback() {
    this.refresh()
  }
  
  refresh() {
    const included_amount = this.charge.get_an_included_amount(this.data)
    const additional_price = this.charge.get_an_additional_usage_price(this.data)
    let featureDescription = (this.showFeatureDescriptionInEditor) ? `<label>${this.charge.data.description}</label><br/>` : ''

    const is_new_feature = typeof this.charge.data.id === 'string'
    let hide_input_field = this.charge.data.hide_quantity_input_field
    let included_amount_field_disabled = ! this.charge.data.editable

    // if the additional fee value is 0, it should always be editable.
    let additional_fee_field_disabled = !(additional_price === 0 || this.charge.data.editable)

    if (is_new_feature){
      included_amount_field_disabled = false
      additional_fee_field_disabled = false
    }
    
    this.innerHTML = `
      <div class="charge_period_parent_container">
        <div class="charge_period_container">
          <div class="two_column_container">
            <div class="quantity_fields_container grid_column">
              ${featureDescription}
              <label 
                for="tier_high_value" 
                class="included_quantity ${hide_input_field ? "hide" : ""}">Included ${this.charge.data.quantity_text}
              </label>
              <input 
                class="form-control ${hide_input_field ? "hide" : ""}" 
                type="number" 
                min="0"
                id="tier_high_value" 
                ${included_amount_field_disabled ? "disabled" : ""}
                value="${included_amount}"
              />
            </div>


            <div class="feature_editor_checkbox_container grid_column">
              <div class="quantity_fields_container">
                <label class="checkbox_container">
                  <span 
                    class="w-form-label" 
                    for="Has-additional-usage-charges">Additional fee per ${this.charge.data.price_text}
                  </span>
                </label>
                <input 
                  class="form-control"
                  type="text" 
                  id="price" 
                  ${additional_fee_field_disabled ? "disabled" : ""}
                  value="${additional_price}"
                >
              </div>
            </div>
          </div>
        </div>
      </div>     
    `

    this.init_events()
  }

  init_events() {
    // add error class when the value is illegal 
    this.querySelector('#tier_high_value').addEventListener('input', this.handle_tier_high_value_change.bind(this))

    this.querySelector('#price').addEventListener('input', this.handle_additional_price_value_change.bind(this))
  }

  handle_tier_high_value_change(){
    const el = this.querySelector('#tier_high_value')
    const v = parseFloat(el.value)
    this.charge.update_tier_high_value(v)
    this.dispatchFeatureUpdatedEvent()
  }
  
  handle_additional_price_value_change(){
    const el = this.querySelector('#price')
    const v = parseFloat(el.value)
    this.charge.set_additional_usage_price(v)
    this.dispatchFeatureUpdatedEvent()
  }

  dispatchFeatureUpdatedEvent(){
    this.dispatchEvent(new CustomEvent('feature_updated', 
      {bubbles: true, composed: true, detail: {data: this.charge.data}}
    ))  
  }  
}
customElements.define("charge-period-editor", ChargePeriodEditor)
